import HomeComp from 'components/Home/index.vue'
import SinglePlantComp from 'components/SinglePlant/index.vue'
import AboutComp from 'components/About/index.vue'
export default [
  {
    path: '/',
    component: HomeComp,
    name: 'home',
    beforeEnter: (to, from, next) => {
      document.body.classList.remove('beige')
      document.body.classList.add('black')
      next()
    }
  },
  {
    path: '/plante/:slug',
    component: SinglePlantComp,
    name: 'single-plant',
    beforeEnter: (to, from, next) => {
      document.body.classList.remove('black')
      document.body.classList.add('beige')
      next()
    }
  },
  {
    path: '/apropos',
    component: AboutComp,
    name: 'about',
    beforeEnter: (to, from, next) => {
      document.body.classList.remove('black')
      document.body.classList.add('beige')
      next()
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]



/** WEBPACK FOOTER **
 ** ./src/router/routes.js
 **/